import { useLocation } from "@reach/router"
import Cookies from "js-cookie"
import { locales, Locale } from "../../locales"

const defaultLang: Locale = "default"

/**
 * Hook to determine the current locale and preferred language.
 * @returns An object containing the current locale and the preferred language.
 */
const useLocale = (): { locale: Locale; preferredLang: Locale } => {
  const { pathname } = useLocation()

  // Determine the locale from the pathname
  let locale = pathname.split("/")[1]
  if (!locales.includes(locale as Locale))
    locale = defaultLang
  const typedLocale = locale as Locale

  // Determine the preferred language from cookies or the current locale
  const cookieLang = Cookies.get("wg_preferred_lang") as Locale | undefined
  const validCookieLang = cookieLang && locales.includes(cookieLang) ? cookieLang : null

  const preferredLang =
    typedLocale === defaultLang && validCookieLang
      ? validCookieLang
      : typedLocale

  return { locale: typedLocale, preferredLang }
}

export default useLocale
